import $ from 'jquery'
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'
import { getTextNodesIn } from '../functions'

imagesLoaded.makeJQueryPlugin($)

let iso = ''

const parent = $('.pt-help-center__posts')
if (parent.length) {
  iso = new Isotope('.pt-help-center__posts', {
    itemSelector: '.feed-faq-grid',
    percentPosition: true,
    masonry: {
      columnWidth: '.pt-help-center__sizer',
    },
  })

  parent.imagesLoaded(function () {
    iso.layout()
  })

  $('.pt-help-center .header-blog__terms li button').on('click', function () {
    const $this = $(this)
    const all = $('.pt-help-center .header-blog__terms li button')
    const val = $this.attr('data-id') * 1

    all.not($this).removeClass('active')

    if (!val) {
      iso.arrange({ filter: '*' })
      $this.addClass('active')
      return
    }

    if ($this.hasClass('active')) {
      iso.arrange({ filter: '*' })
      all.eq(0).addClass('active')
      $this.removeClass('active')
      return
    }

    iso.arrange({
      filter: function () {
        const faq = $(this)

        if (faq.hasClass('pt-help-center__sizer')) {
          return false
        }

        const attr = faq.attr('data-categories')
        const faqs = attr.includes(',') ? attr.split(',') : [attr]
        const newFaqs = faqs.map(Number)

        return newFaqs.includes(val)
      },
    })

    $this.addClass('active')
  })

  const adminBarHeight = $('#wpadminbar').length ? $('#wpadminbar').height() : 0
  const headerHeight = $('#masthead').length ? $('#masthead').height() : 0
  let offset = 15
  offset += adminBarHeight
  offset += headerHeight

  $('.pt-help-center .search-form').on('submit', function (e) {
    e.preventDefault()
    const query = $('.pt-help-center__search').val()

    const regex = new RegExp(query, 'gi')

    iso.arrange({
      filter: function () {
        const text = getTextNodesIn($(this)[0])
        return regex ? text.match(regex) : true
      },
    })
  })

  iso.on('arrangeComplete', function (filteredItems) {
    if (!filteredItems.length) {
      $('.pt-help-center__no-results').show()
      offset += 35
    } else {
      $('.pt-help-center__no-results').hide()
    }

    $('html, body').animate(
      {
        scrollTop: $('.pt-help-center__posts').offset().top - offset,
      },
      500
    )

    if (!filteredItems.length) {
      $('.pt-help-center__no-results').show()
      offset -= 35
    }
  })

  $('.feed-faq-grid').each(function () {
    const defaultHeight = 100
    const cur = $(this)
    const text = cur.find('.feed-faq-grid__content')
    const textHeight = text[0].scrollHeight
    const button = cur.find('.feed-faq-grid__more')
    text.css({ 'max-height': defaultHeight, overflow: 'hidden' })

    if (textHeight <= 100) {
      button.hide()
    }

    button.on('click', function () {
      let newHeight = 0
      if (button.hasClass('active')) {
        newHeight = defaultHeight
        button.removeClass('active')
      } else {
        newHeight = textHeight
        button.addClass('active')
      }
      text.animate(
        {
          'max-height': newHeight,
        },
        250
      )

      setTimeout(() => {
        iso.layout()
      }, 250)
    })
  })
}
